import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import DialogContent from "@material-ui/core/DialogContent";
import MaterialDatePicker from "material-ui-pickers/DatePicker";
import FormHelperText from "@material-ui/core/FormHelperText";
import Dropdown from "components/Global/Dropdown/Dropdown";

export const StyledGrid = styled(Grid)`
  margin-top:16px;
`;
export const StyledDropdown = styled(Dropdown)`{
    
}`;
export const Label = styled.div`
  font-size:17px;
`;
export const LabelGrid = styled(Grid)`&& {
    width: 200px;
  }`;

export const StyledDialogContent = styled(DialogContent)` 
  min-height: 455px;
  max-height: 560px;
  width: 700px;
`;

export const HelperTextDiv = styled.div` &&&&&{
  margin-left: 25px;
}`;
export const StyledFormHelperText = styled(FormHelperText)`
  &&&&&{  
    color: red;  
}`;
export const AlertDropdownGrid = styled(Grid)`
  && {
    margin-top:13px;
  }
`;
export const AdjustedDropdownGrid = styled(Grid)`
  display:flex;
  height:57px; 
  align-items: flex-end; 
`;
export const AdjustedLabelGrid = styled(Grid)`
  height:57px;
  position:relative;
  width:27px;
`;
export const AdjustedLabel = styled(Label)`
  position: absolute;
  top: 22px;
`;
export const StyledMaterialDatePicker = styled(MaterialDatePicker)`
  & input {
    font-size:17px;
  }
  & label {
    font-size:17px;
  }
  && {
    border-bottom: 1px solid #2196F3;
    transition: 0.3s;
  }  
`;
export const VerticalSpacer = styled.div`
  height:24px;
`;
